import * as React from "react";
import * as ReactDOM from "react-dom";
import CssBaseline from "@mui/material/CssBaseline";

import "./index.css";

import { App } from "./app";
import { CustomThemeProvider } from "./services/providers/theme";

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <CustomThemeProvider>
    <>
      <CssBaseline />
      <App />
    </>
  </CustomThemeProvider>,
  document.getElementById("root")
);
